import ChatMessage from "@/ui/components/ChatMessage";

export default function MessageList({ messages }) {
  return (
    <div className={`flex flex-col gap-4 p-2 w-full`}>
      {messages.map((message, index) =>
        message.utterance ? <ChatMessage key={index} message={message} /> : null
      )}
    </div>
  );
}
